import { defineMessages } from 'react-intl';

export const messages: {
	buttonTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	frameAboveImageLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	solidColorBackgroundLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	splitDesignLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	buttonTitle: {
		id: 'company-hub.carousel-extension.config-panel.layout.title',
		defaultMessage: 'Choose a layout',
		description:
			'The text is shown as the heading above the layout selection buttons in the carousel extension config panel, prompting users to select a carousel layout style.',
	},
	frameAboveImageLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label',
		defaultMessage: 'Text with frame above image',
		description:
			'The text is shown as the label for the frame-above-image layout option in the carousel config panel, where the text frame appears above the image in each carousel slide.',
	},
	splitDesignLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.split-design-content.label',
		defaultMessage: 'Split design',
		description:
			'The text is shown as the label for the split design layout option in the carousel config panel, where content and image are displayed side by side in each carousel slide.',
	},
	solidColorBackgroundLabel: {
		id: 'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label',
		defaultMessage: 'Solid color background',
		description: 'Solid color background layout option label',
	},
});
